import { render, staticRenderFns } from "./FeaturesPage.vue?vue&type=template&id=70430a03&scoped=true&"
import script from "./FeaturesPage.vue?vue&type=script&lang=js&"
export * from "./FeaturesPage.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesPage.vue?vue&type=style&index=0&id=70430a03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70430a03",
  null
  
)

export default component.exports